export const SPECIAL_OFFERS_TEST_ID = {
    OFFERS_BLOCK: 'special-offers-block',
    OFFER_BTN: 'special-offer-button',
    ROUND_FILLED_ICON: 'round-filled-icon',
    SINGLE_MODAL: 'special-offer-single-modal',
    GIFT_MODAL: 'special-offer-gift-modal',
};
